import { Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { GroupService } from 'app/main/settings/accounts/groups/services/groups-api.service';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { Group } from '../../../../interfaces';


export function ValidateAutocomplete(): object {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UserGroupLegacyComponent),
  multi: true
};

@Component({
  selector: 'user-group-legacy',
  templateUrl: './user-group.component.html',
  styleUrls: ['./user-group.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class UserGroupLegacyComponent implements ControlValueAccessor, OnInit {
  public groups = new Array<Group>();
  public inputValue = new FormControl();
  public hasSelectedGroup: boolean;
  public selectedGroup: Group;
  public loading = false;

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService, private groupsService: GroupService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
  }

  ngOnInit(): void {
    this.inputValue.valueChanges
      .pipe(
        filter((searchTerm) => {
          return !!searchTerm;
        }),
        debounceTime(500),
        switchMap((searchTerm) => {
          this.loading = true;
          this.groups = [];
          return this.groupsService.loadData({
            where: {
              name_contains: searchTerm
            },
            options: {
              orderBy: 'name_asc',
              offset: 0,
              limit: 10
            }
          });
        })
      )
      .subscribe((result) => {
        this.loading = false;
        this.groups = result.items;
      });
  }

  onChange: (_: any) => void = () => {};
  onTouched: (_: any) => void = () => {};

  writeValue(groupId: any): void {
    if (groupId) {
      this.groupsService.getGroupById(groupId).then((group) => {
        this.selectedGroup = group;
        this.hasSelectedGroup = true;
        this.inputValue.setErrors(null);
      });
    } else {
      this.deselectGroup();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedGroup(): void {
    if (this.inputValue.value) {
      this.onChange(this.inputValue.value);
      this.selectedGroup = this.groups.find((group) => group.id === this.inputValue.value) as Group;
      this.hasSelectedGroup = true;
      this.inputValue.setErrors(null);
    }
  }

  deselectGroup(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedGroup = null;
    this.hasSelectedGroup = false;
    this.inputValue.setErrors(null);
  }
}
